import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Stats({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(StatsStyled, {
    ...props,
    children
  });
}
const StatsStyled = styled.div.withConfig({
  displayName: "StatsStyled",
  componentId: "sc-a5kvvv-0"
})(["display:flex;flex-wrap:wrap;row-gap:", ";padding:var(--card-content-padding);border-top:1px solid ", ";column-gap:", ";"], token.spacing4, token.gray100a, token.spacing5);
export {
  Stats
};
//# sourceMappingURL=Stats.js.map
